export var ActionType;
(function (ActionType) {
    ActionType["SET_ACCOUNT_ID"] = "SET_ACCOUNT_ID";
    ActionType["SET_CONTEXT"] = "SET_CONTEXT";
    ActionType["SET_CURRENT_LANGUAGE"] = "SET_CURRENT_LANGUAGE";
    ActionType["SET_CURRENT_ROUTE"] = "SET_CURRENT_ROUTE";
    ActionType["SET_AUTOPAY_STATUS"] = "SET_AUTOPAY_STATUS";
})(ActionType || (ActionType = {}));
//# sourceMappingURL=types.js.map